<style module>
    .container {
        display: flex;
        gap: 20px;
    }

    .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 9px 14px;
        width: 139px;
        height: 97px;
        background: var(--blue-soap);
        border: 1px solid var(--color-solitude);
        border-radius: 8px;
    }

    .number {
        height: 25px;
        width: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        text-align: center;
        color: var(--dodger-blue);
        border: 1px solid var(--dodger-blue);
        border-radius: 50%;
        margin-bottom: 10px;
    }

    .text {
        width: 95px;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: var(--regent-gray);
    }
</style>

<div class="container">
    <div class="step">
        <div class="number">1</div>
        <p class="text">Check your text messages</p>
    </div>
    <div class="step">
        <div class="number">2</div>
        <p class="text">Confirm the sign up</p>
    </div>
    <div class="step">
        <div class="number">3</div>
        <p class="text">Get coupon & start saving</p>
    </div>
</div>
